import { ModalService } from 'src/app/shared/services/modal/modal.service';
import { Component, OnInit } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { TranslateService } from '@ngx-translate/core';
import { remove } from 'lodash';
import { forkJoin } from 'rxjs';
import { RefSystemeIrrigation } from 'src/app/data/declaration/models/ref-systeme-irrigation.model';
import { RefSystemeIrrigationService } from 'src/app/data/declaration/services/parcellaire/ref-systeme-irrigation.service';
import { LoaderService } from '../../../../../../../../core/services/loader/loader.service';

@Component({
    selector: 'app-liste-systemes-irrigations',
    templateUrl: './liste-systemes-irrigations.component.html',
    styleUrls: ['./liste-systemes-irrigations.component.scss'],
    standalone: false
})
export class ListeSystemesIrrigationsComponent implements OnInit {
    irrigations: RefSystemeIrrigation[];

    constructor(
        private readonly loaderService: LoaderService,
        private readonly modalsService: ModalService,
        private readonly translate: TranslateService,
        private readonly irrigationService: RefSystemeIrrigationService,
        private readonly router: Router,
        private readonly route: ActivatedRoute
    ) {}

    ngOnInit() {
        this.irrigationService
            .getRefSystemeIrrigation()
            .pipe(this.loaderService.operator())
            .subscribe(irrigations => {
                this.irrigations = irrigations;
            });
    }

    openConfirmationDialog(irrigation: RefSystemeIrrigation) {
        this.modalsService
            .confirm('Veuillez confirmer', "Voulez vous supprimer le système d'irrigation " + irrigation.libelle + ' ?', {
                cancelText: this.translate.instant('label.annuler'),
                submitText: this.translate.instant('label.confirmer'),
                windowClass: 'anpp'
            })
            .then(
                () => {
                    this.deleteIrrigation(irrigation);
                },
                () => {}
            );
    }

    deleteIrrigation(irrigation: RefSystemeIrrigation) {
        this.irrigationService.desactiverRefSystemeIrrigation(irrigation).subscribe(() => {
            remove(this.irrigations, irrigation);
        });
    }

    editIrrigation(irrigation: RefSystemeIrrigation) {
        this.modalsService
            .confirm('Veuillez confirmer', this.translate.instant('page.valeur_parametrable.message_modification'), {
                cancelText: this.translate.instant('label.annuler'),
                submitText: this.translate.instant('label.confirmer'),
                windowClass: 'anpp'
            })
            .then(
                () => {
                    this.router.navigate(['edit', irrigation.id], { relativeTo: this.route });
                },
                () => {}
            );
    }
}
